import * as Joi from "joi";
import { Moment } from 'moment';
import { Column, Entity } from 'typeorm';
import { GenPartial, momentTransformer } from 'typeormgen';
import EpisodicBase from '../episodic-base.entity';
import { EPISODIC_FLAG_TYPES } from '../enums/enums';

@Entity('episodic_flags')
export default class EpisodicFlag extends EpisodicBase {
	static tableName = 'episodic_flags';

	@Column('int')
	flag_type: EPISODIC_FLAG_TYPES;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	last_updated_time: Moment;

	@Column({ type: 'timestamp', transformer: momentTransformer })
	date_created: Moment;

	toJSON() {
		return {
			...super.toJSON(),
			flag_type: this.flag_type,
		};
	}

	static rules() {
		return {
			...super.rules(),
			flag_type: Joi.number(),
		};
	}

	assign(props?: GenPartial<EpisodicFlag>) {
		super.assign(props);
	}

	constructor(props?: GenPartial<EpisodicFlag>) {
		super(props);
	}
}
